// Where "Get the badge" sends a merchant: the Rivyou app listing on the Shopify App Store.
export const SHOPIFY_APP_URL = "https://apps.shopify.com/rivyou";

export const openShopifyApp = () => window.open(SHOPIFY_APP_URL, "_blank", "noopener,noreferrer");
